import { Scrollprogress } from '@nrk/dh-basis-scrollanimasjon'
import { ViewportPositionMixin } from '@nrk/dh-basis-mixins'
import styles from './animasjonsscroll.module.css'
import './animasjonsscroll.template-adjustments.module.css'

export default class Animasjonsscroll extends ViewportPositionMixin(Scrollprogress) {
  connectedCallback() {
    super.connectedCallback()
    this._class = styles.animasjonsscroll
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  get defaultProgress() {
    if (this.reduceMotion?.type === 'auto') {
      return this.reduceMotion.defaultValue
    } else {
      return 1
    }
  }
}
